//Extras
import React, { useEffect, useState } from 'react'
import { main, fontType } from '../assets/extras'
import { getAge, getCurrentDate, validateEmail, validatePhone } from '../assets/validator'
import { useLocation, useNavigate } from 'react-router-dom'

//Styles
import './styles/inscriptionForm.css'

//Connections
import { db } from '../assets/connections'
import { getDoc, doc, setDoc, addDoc, collection, updateDoc, getDocs, query, orderBy, where, increment, deleteDoc } from 'firebase/firestore'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import { MdDeleteOutline } from "react-icons/md"
import { horas } from '../assets/datas'

const InscriptionFormMuestra = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const correo = location.state ? location.state.correo : null
    const edad = location.state ? location.state.edad : null
    const nivel = location.state ? location.state.nivel : null
    const nombre = location.state ? location.state.nombre : null
    const telefono = location.state ? location.state.telefono : null
    const id_clase = location.state ? location.state.clase : null
    const id = location.state ? location.state.id : null
    const academia = location.state ? location.state.academia : null

    const [variables, setVariables] = useState({
        loading: true,
        classes: [],
        data: {}
    })

    //Datos del usuario
    const [data, setData] = useState({
        categoria_jugador: typeof edad !== "string" ? "" :
            getAge(edad) >= 4 || getAge(edad) < 8 ? "Infantil 4 a 8 años" :
                getAge(edad) >= 8 || getAge(edad) < 12 ? "Infantil 8 a 12 años" :
                    getAge(edad) >= 12 || getAge(edad) < 18 ? "Juvenil 12 a 18 años" :
                        getAge(edad) >= 18 ? "Adultos" : ""
        ,
        correo_jugador: correo,
        edad_jugador: typeof edad !== "string" ? "" : edad,
        nivel_jugador: nivel,
        nombre_jugador: nombre.toLowerCase()
            .split(" ")
            .map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1))
            .join(" "),
        a_p: "",
        a_m: "",
        rama_jugador: "",
        telefono_jugador: telefono ? telefono : "",
        clases_jugador: id_clase ? [id_clase] : []
    })

    //Validador de los terminos y condiciones
    const [checked, setChecked] = useState(false)

    //Variable que almacena los datos ordenados por dias
    var sortedDaysData = [
        [], //Lunes
        [], //Martes
        [], //Miercoles
        [], //Jueves
        [], //Viernes
        [], //Sabado
        [], //Domingo
    ]

    //Funcion que busca a que dia pertenece la clase
    const sortByDay = (clase) => {
        for (let i = 0; i < 7; i++) {
            if (i === 0) { //Lunes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Lunes") {
                        sortedDaysData[i].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 1) { //Martes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Martes") {
                        sortedDaysData[i].push(clase)
                        cont++;
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 2) { //Miercoles
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Miercoles") {
                        sortedDaysData[i].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 3) { //Jueves
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Jueves") {
                        sortedDaysData[i].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 4) { //Viernes
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Viernes") {
                        sortedDaysData[i].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 5) { //Sabado
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Sabado") {
                        sortedDaysData[i].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            } else if (i === 6) { //Domingo
                let cont = 0
                for (let j = 0; j < clase.dias_clase.length; j++) {
                    if (clase.dias_clase[j].dia === "Domingo") {
                        sortedDaysData[i].push(clase)
                        cont++
                        break
                    }
                }

                if (cont > 0) {
                    break
                }
            }
        }
    }

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Funcion que formatea el subitulo
    const formatSubtitle = (dias_clase) => {
        var dias = ""
        dias_clase.map(v => {
            var dia = ""
            var hora = v.de + "-" + v.a
            for (let i = 0; i < 3; i++) {
                dia += v.dia[i]
            }

            if (dias == "") {
                dias = dia + " " + hora
            } else {
                dias += " / " + dia + " " + hora
            }

        })

        return dias
    }

    //Funcion que envia el mensaje por correo
    const sendMessage = async () => {
        await fetch("https://us-central1-tenistapp2000.cloudfunctions.net/correoBienvenida", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                correo: data.correo_jugador,
                nombre: data.nombre_jugador,
                academia: academia,
            }),
        }).then((success) => {
            console.log(success)
        }).catch((error) => {
            console.log(error)
        })
    }

    //Funcion que quita al jugador de una clase en especifico
    const takeOutPlayer = (index) => {
        data.clases_jugador.splice(index, 1)
        setData(prev => ({
            ...prev
        }))
    }

    //Funcion que valida si el jugador ya esta en la clase que se quiere registrar
    const isInClass = (itemValue) => {
        itemValue = JSON.parse(itemValue)

        if (itemValue.id != "") {

            var count = 0
            for (let i = 0; i < data.clases_jugador.length; i++) {
                if (data.clases_jugador[i] == itemValue.id) {
                    count++
                }
            }

            if (count > 0) {
                setTimeout(() => {
                    showMessage("El jugador ya esta registrado en esa clase", "warning")
                }, 100)
            } else {

                var limite = itemValue.limite_jugadores
                if (limite === null || limite === "" || parseInt(limite) === 0) {
                    data.clases_jugador.push(itemValue.id)
                    setData(prev => ({
                        ...prev
                    }))
                } else {
                    if ((itemValue.numero_jugadores + 1) <= limite) {
                        data.clases_jugador.push(itemValue.id)
                        setData(prev => ({
                            ...prev
                        }))
                    } else {
                        showMessage("Ya no hay espacio en la clinica", "warning")
                    }
                }
            }
        }
    }

    //Funcion al hacer clic en el boton de guardar
    const onHandleGuardar = () => {
        if (data.nombre_jugador && data.telefono_jugador && data.rama_jugador && data.edad_jugador) {
            if (validateEmail(data.correo_jugador)) {
                if (validatePhone(data.telefono_jugador)) {
                    if (checked == true) {
                        //Aqui se manda la informacion a la base de datos
                        setVariables(prev => ({
                            ...prev,
                            loading: true
                        }))
                        loadingData()
                    } else {
                        showMessage("Debes aceptar los terminos y condiciones", "warning")
                    }
                } else {
                    showMessage("Telefono invalido", "warning")
                }
            } else {
                showMessage("Debes agregar un correo valido", "warning")
            }
        } else {
            if (!data.edad_jugador) {
                showMessage("La fecha de nacimiento es incorrecta.", "warning")
            } else {
                showMessage("Debes completar todos los campos.", "warning")
            }
        }
    }

    //Funcion que carga los datos a la bd 
    const loadingData = async () => {
        if (data.correo_jugador) {
            getPlayer()
        }
    }
    //Funcion que valida si el jugador esta en la base de datos de una academia
    const getPlayer = async () => {
        await getDoc(doc(doc(db, ref), "Jugador", data.correo_jugador)).then(r => {
            if (r.exists()) {
                //Aqui se manda la informacion a la base de datos
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("El jugador ya esta registrado en la academia", "warning")
                }, 100)
            } else {
                loadData()
            }
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }
    //Funcion que sube los datos del jugador a la base de datos
    const loadData = async () => {
        const edadAux = getAge(data.edad_jugador)

        const newData = {
            asistencias: [],
            categoria_jugador: edadAux > 0 && edadAux <= 8 ? "Infantil 4 a 8 años" :
                edadAux > 8 && edadAux <= 12 ? "Infantil 8 a 12 años" :
                    edadAux > 12 && edadAux < 18 ? "Juvenil 12 a 18 años" :
                        edadAux > 18 ? "Adultos" : "",
            clases_jugador: data.clases_jugador,
            correo_jugador: data.correo_jugador,
            edad_jugador: data.edad_jugador,
            suscripciones_jugador: [
                {
                    suscripcion: "Inscripcion",
                    fecha_pago: "----/--/--",
                    pagado: 0,
                    por_pagar: 0,
                    comentarios: ""
                },
                {
                    suscripcion: "Mensualidad",
                    fecha_pago: "----/--/--",
                    pagado: 0,
                    por_pagar: 0,
                    comentarios: ""
                }
            ],
            nivel_jugador: data.nivel_jugador,
            nombre_jugador: data.nombre_jugador + " " + data.a_p + " " + (data.a_m ? data.a_m : ""),
            rama_jugador: data.rama_jugador,
            ranking_jugador: 0,
            telefono_jugador: data.telefono_jugador,
            ultima_asistencia: "0000-00-00",
            fecha_alta: getCurrentDate(),
            fecha_baja: "----/--/--"
        }

        await setDoc(doc(doc(db, ref), "Jugador", newData.correo_jugador), newData).then(async r => {
            await updateClassCont(data.clases_jugador)
            await deletingClass()
            await sendMessage()
            setData({
                categoria_jugador: "",
                correo_jugador: "",
                edad_jugador: "",
                nivel_jugador: "",
                nombre_jugador: "",
                a_p: "",
                a_m: "",
                rama_jugador: "",
                telefono_jugador: "",
                clases_jugador: []
            })
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Jugador registrado correctamente", "success")
                setTimeout(() => {
                    navigate("/players/player", {
                        replace: true,
                        state: {
                            ref: ref,
                            id: id,
                            academia: academia
                        }
                    })
                }, 1500)
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
        })
    }
    //Funcion que actualiza el contador de jugadores de la clinica
    const updateClassCont = async (classes) => {
        classes.map(async v => {
            await updateDoc(doc(doc(db, ref), "Clases", v), {
                numero_jugadores: increment(1)
            }).catch(e => {
                console.log(e)
            })
        })
    }
    //Funcion que borra a la clase muestra
    const deletingClass = async () => {
        await deleteDoc(doc(db, "ClaseMuestra", id)).catch(e => {
            console.log(e)
            showMessage("Error al eliminar clase muestra", "error")
        })
    }

    //Funcion que obtiene las clases
    const getClasses = async () => {
        await getDocs(query(collection(doc(db, ref), "Clases"), orderBy("nombre_profesor", "asc"))).then(r => {

            var aux = []

            r.docs.map(v => {
                if (v.id.split("-").length === 1) {
                    var datos = v.data()

                    var newObject = {
                        id: v.id,
                        descripcion_clase: datos.descripcion_clase,
                        nombre_clase: datos.nombre_clase,
                        nombre_profesor: datos.nombre_profesor,
                        dias_clase: datos.dias_clase,
                        limite_jugadores: datos.limite_jugadores,
                        nivel_clase: datos.nivel,
                        numero_jugadores: datos.numero_jugadores
                    }
                    aux.push(newObject)
                }
            })

            //Ordenamos cada clase de la lista de las categorias por dias
            for (let i = 0; i < aux.length; i++) {
                //Recibimos una sola clase de la lista+
                sortByDay(aux[i])
            }

            var aux2 = []
            //Una vez separadas las clases por dias, y teniendo un arreglo de clases por cada dia,
            //Ordenamos la lista que esta en los martes por ejemplo de menor a mayor
            for (let i = 0; i < sortedDaysData.length; i++) {

                //Primero creamos una variable que contendra las horas de clase
                var h = horas.map((v, i) => [])

                for (let x = 0; x < sortedDaysData[i].length; x++) {

                    //Creamos una variable que almacena las horas de comienzo de cada clase
                    var start = []

                    //Recorremos cada dia de las clases
                    for (let z = 0; z < sortedDaysData[i][x].dias_clase.length; z++) {
                        //Las agregamos a la variable de almacenamiento de las horas (ahora en formato "HH:MM")
                        start.push(sortedDaysData[i][x].dias_clase[z].de)
                    }


                    //Ahora validamos recorriendo las horas a cual pertenece cada una
                    for (let z = 0; z < h.length; z++) {
                        // Comparar directamente con el valor en horas[z] (formato "HH:MM")
                        if (start.includes(horas[z])) {
                            h[z].push(sortedDaysData[i][x])
                            break
                        }
                    }

                }

                h.map((v, i) => {
                    v.map(v2 => {
                        aux2.push(v2)
                    })
                })

            }

            setVariables(prev => ({
                ...prev,
                classes: aux2,
                loading: false
            }))

        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    useEffect(() => {
        if (!sessionStorage.getItem("homeFlag") || ref === null) {
            navigate("/home", { replace: true })
        } else {
            document.title = "Registro"

            getClasses()
        }
    }, [])

    if (variables.loading)
        return (
            <Loader loading={variables.loading} />
        )

    if (!variables.loading)
        return (
            <div style={{
                flex: 1
            }}>
                <Snack />

                <div style={{
                    backgroundColor: main,
                    width: "100%",
                    height: 80,
                    display: "flex ",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <h1 style={{
                        fontFamily: fontType.title,
                        color: "white",
                    }}>REGISTRO DE DATOS</h1>
                </div>

                <div className="cont11">
                    <div className='cont'>
                        <h2 style={{ fontFamily: fontType.subTitle }}>DATOS PERSONALES</h2>

                        <div className='contInput'>
                            <p style={{ fontFamily: fontType.subTitle }}>Nombre*</p>
                            <input style={{ fontFamily: fontType.text }}
                                onChange={e => setData({ ...data, nombre_jugador: e.target.value })}
                                value={data.nombre_jugador}
                                maxLength={30}
                                placeholder='Nombre(s)'
                            />
                        </div>
                        <div className='contInput'>
                            <p style={{ fontFamily: fontType.subTitle }}>Apellido paterno</p>
                            <input style={{ fontFamily: fontType.text }}
                                onChange={e => setData({ ...data, a_p: e.target.value })}
                                value={data.a_p}
                                maxLength={30}
                                placeholder='(Opcional)'
                            />
                        </div>
                        <div className='contInput'>
                            <p style={{ fontFamily: fontType.subTitle }}>Apellido materno</p>
                            <input style={{ fontFamily: fontType.text }} placeholder="(Opcional)"
                                onChange={e => setData({ ...data, a_m: e.target.value })}
                                value={data.a_m}
                                maxLength={30}
                            />
                        </div>
                        <div className='contInput'>
                            <p style={{ fontFamily: fontType.subTitle }}>Telefono*</p>
                            <input style={{ fontFamily: fontType.text }}
                                placeholder='10 Digitos (ej. 5543657452)'
                                onChange={e => setData({ ...data, telefono_jugador: e.target.value.replace(" ", "") })}
                                value={data.telefono_jugador}
                                maxLength={10}
                            />
                        </div>
                        <div className='contInput'>
                            <p style={{ fontFamily: fontType.subTitle }}>Fecha de nacimiento ({data.edad_jugador ? data.edad_jugador : "No hay una fecha registrada"})*</p>
                            <input style={{ fontFamily: fontType.text }} type="date"
                                onChange={e => setData({ ...data, edad_jugador: e.target.value })}
                                value={data.edad_jugador}
                            />
                        </div>
                        <div className='contInput'>
                            <p style={{ fontFamily: fontType.subTitle }}>Correo*</p>
                            <input style={{ fontFamily: fontType.text }}
                                onChange={e => setData({ ...data, correo_jugador: e.target.value.replace(" ", "").toLowerCase() })}
                                value={data.correo_jugador}
                                maxLength={50}
                                placeholder={'ejemplo@gmail.com'}

                            />
                        </div>
                    </div>

                    <div className='cont'>

                        <h2 style={{ fontFamily: fontType.subTitle }}>DATOS DEPORTIVOS</h2>

                        <div className='contSportData'>
                            <div className='contSelect'>
                                <p style={{ fontFamily: fontType.subTitle }}>Rama*</p>
                                <select id="rama" style={{ fontFamily: fontType.subTitle }}
                                    onChange={e => setData({ ...data, rama_jugador: e.target.value })}
                                    value={data.rama_jugador}
                                >
                                    <option value=""></option>
                                    <option value="Varonil">Varonil</option>
                                    <option value="Femenil">Femenil</option>
                                </select>
                            </div>
                            <div className='contSelect'>
                                <p style={{ fontFamily: fontType.subTitle }}>Nivel*</p>
                                <select id="nivel" style={{ fontFamily: fontType.subTitle }}
                                    onChange={e => setData({ ...data, nivel_jugador: e.target.value })}
                                    value={data.nivel_jugador}
                                >
                                    <option value="">(Opcional)</option>
                                    <option value="Etapa roja">Etapa roja</option>
                                    <option value="Etapa naranja">Etapa naranja</option>
                                    <option value="Etapa verde">Etapa verde</option>
                                    <option value="Clase D">Clase D</option>
                                    <option value="Clase C">Clase C</option>
                                    <option value="Clase B">Clase B</option>
                                    <option value="Clase A">Clase A</option>
                                    <option value="Profesional">Profesional</option>
                                </select>
                            </div>
                        </div>

                        <p style={{ fontFamily: fontType.subTitle, marginTop: 50, width: "100%", textAlign: "center" }}>SELECCIONA UNA CLASE PARA EL JUGADOR</p>

                        <div className='custom-select'>
                            <select id="Clases" name="Clases" style={{
                                fontFamily: fontType.text,
                                width: "100%"
                            }}
                                value={"..."}
                                onChange={e => {
                                    isInClass(e.target.value)
                                }}
                            >
                                <option value={""}>...</option>
                                {
                                    variables.classes.map((v, i) => {
                                        return (
                                            <option style={{
                                                borderBottomWidth: 1
                                            }} value={JSON.stringify({ id: v.id, limite_jugadores: v.limite_jugadores, numero_jugadores: v.numero_jugadores })}>{(v.dias_clase ? formatSubtitle(v.dias_clase) : "") + " " + v.nombre_profesor}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>

                        <div className='contClasses' style={{
                            fontFamily: fontType.text
                        }}>
                            {
                                data.clases_jugador.length > 0 ?
                                    data.clases_jugador.map((v, i) => {
                                        let clase = variables.classes.find(c => c.id == v)
                                        return (
                                            <div className='clase'>
                                                <div className='item' style={{
                                                    cursor: "pointer"
                                                }}>
                                                    <p style={{
                                                        fontWeight: "bold",
                                                        marginBottom: 20
                                                    }}>{clase.nombre_profesor}</p>
                                                    <p>{clase.nombre_clase}</p>
                                                    <p>{clase.descripcion_clase}</p>
                                                </div>
                                                <div className='item' style={{
                                                    cursor: "pointer"
                                                }}
                                                    onClick={() => {
                                                        takeOutPlayer(i)
                                                    }}
                                                >
                                                    <MdDeleteOutline size={30} color='black' />
                                                </div>
                                            </div>
                                        )
                                    })
                                    :
                                    <p style={{
                                        marginTop: 0,
                                        marginBottom: 100,
                                        textAlign: "center",
                                        fontFamily: fontType.text
                                    }}>No hay clases para este jugador.</p>
                            }
                        </div>

                        <div className="contCheckbox">
                            <input type='checkbox' value={checked} onChange={e => setChecked(!checked)} />
                            <p style={{ fontFamily: fontType.text }}>He leido y acepto los
                                <a href='/terms' target='_blank'> terminos y condiciones</a>
                            </p>
                        </div>

                        <div style={{
                            width: "60%",
                            maxWidth: 300,
                            minWidth: 200,
                            marginTop: 50
                        }}>
                            <button style={{
                                fontFamily: fontType.title,
                                backgroundColor: main,
                                width: "100%"
                            }}

                                onClick={onHandleGuardar}>GUARDAR</button>
                        </div>

                    </div>
                </div>
            </div>
        )
}

export default InscriptionFormMuestra